module.exports = __webpack_public_path__ + "static/media/chery.001.28ec35ba.png";